function OSNotify() {
    if (window.gl_perid) {
        if (!localStorage.getItem('stopOSNotify'+gl_perid)) {
            if (!isSupportedOS()) {
                VutBox.dialog(
                    (gl_lang_code=='cs'
                        ?'Používáte zastaralou verzi operačního systému'
                        :'You are using an outdated version of the operating system'
                    ),
                    (gl_lang_code=='cs'
                        ?'Společnost Microsoft ukončila podporu operačního systému Windows 7. Používání systému Windows 7 a starších je z hlediska zabezpečení zařízení a dat na něm uložených rizikové. Požádejte svého správce sítě o upgrade operačního systému na Windows 10, případně proveďte upgrade sami. Doporučený postup, včetně aktivačních klíčů, najdete <a href="https://vut.cz/intra/navody/win10-doma">v tomto návodu</a>.'
                        :'Microsoft has discontinued Windows 7 support. Using Windows 7 and older operating systems is risky concerning the security of the device and the data stored on it. Ask your network administrator to upgrade your operating system to Windows 10, or upgrade it yourself. You will find the recommended procedure, including activation keys, <a href="https://vut.cz/intra/navody/win10-doma"> in this manual (cs)</a>.'
                    ),
                    [
                        {
                            name:(gl_lang_code=='cs'?'Neupozorňovat':'Don’t show again'),
                            callback:function(){localStorage.setItem('stopOSNotify'+gl_perid, 1);},
                            "class":"vutbox-close"
                        },
                        VutBox.CLOSE_PRIMARY_FOCUS_ME
                    ]
                );
            }
        }
    }
}

function isSupportedOS() {

    var clientStrings = [
    // s = název os; spíše orientačně; r = crossbrowser regex pro každý os; sup = true -> systém je podporován; false -> o systému bezpečně víme, že je nepodporován.
        {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/, sup:true},
        {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/, sup:true},
        {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/, sup:true},
        {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/, sup:false},
        {s:'Windows Vista', r:/Windows NT 6.0/, sup:false},
        {s:'Windows Server 2003', r:/Windows NT 5.2/, sup:false},
        {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/, sup:false},
        {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/, sup:false},
        {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/, sup:false},
        {s:'Windows 98', r:/(Windows 98|Win98)/, sup:false},
        {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/, sup:false},
        {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT;)/, sup:false},
        {s:'Windows CE', r:/Windows CE/, sup:false},
        {s:'Windows 3.11', r:/Win16/, sup:false},
/*        {s:'Android', r:/Android/, sup:true},
        {s:'Open BSD', r:/OpenBSD/, sup:true},
        {s:'Sun OS', r:/SunOS/, sup:true},
        {s:'Chrome OS', r:/CrOS/, sup:true},
        {s:'Linux', r:/(Linux|X11(?!.*CrOS))/, sup:true},
        {s:'iOS', r:/(iPhone|iPad|iPod)/, sup:true},
        {s:'Mac OS X', r:/Mac OS X/, sup:true},
        {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/, sup:true},
        {s:'QNX', r:/QNX/, sup:true},
        {s:'UNIX', r:/UNIX/, sup:true},
        {s:'BeOS', r:/BeOS/, sup:true},
        {s:'OS/2', r:/OS\/2/, sup:true},
        {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/, sup:false}
*/    ];
    // pokud zakopnu o svůj OS, vracím jeho sup.
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(navigator.userAgent)) {
            console.log(cs.s, cs.sup);
            return cs.sup;
        }
    }


    return true;

}

// zákaz odeslání formu enterem na inputu
window.addEventListener('keydown', function(event){
    if ((!event.ctrlKey)&&(event.key)&&(event.key.toLowerCase()=='enter')&&event.target.matches('form:not(.form-filter) input:not([type=submit]):not([type=button]):not(.enter-submit)')) {
        event.preventDefault();
        return false;
    }
}, true);

window.addEventListener('click', function(event){
    let target;
    // debug -- teacher/ep3
    if (target = event.target?.closest?.('.swap')) {
        let tg = (target.dataset.target
            ?document.querySelector('#'+target.dataset.target)
            :target.nextElementSibling
        );
        if (tg) { tg.style.display = tg.offsetParent ? 'none' : 'block'; }
        event.preventDefault();
        return false;
    }
}, true);

window.addEventListener('DOMContentLoaded', OSNotify, true);